import React, { useEffect } from 'react';
import { Typography, Grid, Card, CardActionArea, Button, CardContent, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    paper: {
        width: 300,
        marginTop: '20%',
        marginLeft: 'auto',
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(0, 0, 2),
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        position: 'absolute'
    },
    card: {
        width: 300,
        marginTop: '2%',
        marginLeft: '2%',
    },
}));


const DataDashboard = (props) => {
    const classes = useStyles();
    useEffect(() => {
        console.log("DataDashboard props:", props);
        //if (!props.userProfile.isAdmin) {
        //    props.history.push('tekenin');
        //}
    }, [])


    const goToPage = (page) => {
        //changeProjType
        var afterSlash = page.lastIndexOf('/');
        var project = page.substring(afterSlash + 1);
        props.changeProjType.setProject(project);
        props.history.push(page);

    }

    useEffect(() => {
        console.log("app props changed in datadashboard:", props.projectType.project);
    }, [props.projectType.project])

    return (
        <Grid container justify="space-evenly">
            <Grid item lg={12}>
                <Typography variant="h3">Inskrywings Data Dashboard</Typography>
            </Grid>
            <Grid container justify="space-evenly">
                <Card className={classes.card}>
                    <CardActionArea>
                        <CardContent onClick={() => { goToPage('data/digigroei') }}>
                            <Typography gutterBottom variant="h5" component="h2">
                                DigiGroei
                                </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
                <Card className={classes.card}>
                    <CardActionArea>
                        <CardContent onClick={() => { goToPage('data/digikuns') }}>
                            <Typography gutterBottom variant="h5" component="h2">
                                DigiKuns
                                </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
                <Card className={classes.card}>
                    <CardActionArea>
                        <CardContent onClick={() => { goToPage('data/digipraat') }}>
                            <Typography gutterBottom variant="h5" component="h2">
                                DigiPraat
                                </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
                <Card className={classes.card}>
                    <CardActionArea>
                        <CardContent onClick={() => { goToPage('data/digiskryf') }}>
                            <Typography gutterBottom variant="h5" component="h2">
                                DigiSkryf
                                </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
                <Card className={classes.card}>
                    <CardActionArea>
                        <CardContent onClick={() => { goToPage('data/digispanpraat') }}>
                            <Typography gutterBottom variant="h5" component="h2">
                                DigiSpanpraat
                                </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
                <Card className={classes.card}>
                    <CardActionArea>
                        <CardContent onClick={() => { goToPage('data/digispel') }}>
                            <Typography gutterBottom variant="h5" component="h2">
                                DigiSpel
                                </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
                <Card className={classes.card}>
                    <CardActionArea>
                        <CardContent onClick={() => { goToPage('data/digitaal') }}>
                            <Typography gutterBottom variant="h5" component="h2">
                                DigiTaal
                                </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
                <Card className={classes.card}>
                    <CardActionArea>
                        <CardContent onClick={() => { goToPage('data/digitienertoneel') }}>
                            <Typography gutterBottom variant="h5" component="h2">
                                Tienertoneel
                                </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>

            </Grid>
        </Grid>

    )
}
export default DataDashboard;


// WEBPACK FOOTER //
// ./src/components/DataDashboard.js